import React, { Component } from 'react'
import styled from 'styled-components'
import config from '../../../data/SiteConfig'

class Logo extends Component {
  constructor() {
    super()
    this.shrinkLogo = this.shrinkLogo.bind(this)
  }

  componentDidMount() {
    window.addEventListener('scroll', this.shrinkLogo)
  }

  shrinkLogo() {
    const logo = document.getElementById('nav-logo-main')
    if (window.scrollY > 100) {
      logo.style.height = '80px'
      logo.style.width = '120px'
    }
    if (window.scrollY === 0) {
      logo.style.height = '133px'
      logo.style.width = '200px'
    }
  }

  render() {
    return (
      <LogoContainer>
        <img id="nav-logo-main" src={config.siteLogo} alt="logo" />
      </LogoContainer>
    )
  }
}

export default Logo

const LogoContainer = styled.span`
  img {
    transition: all 400ms ease;
    max-height: 200px;
    max-width: 200px;
  }
`



// WEBPACK FOOTER //
// ./src/components/Accessories/NavLogo.jsx